import { lazy } from 'react';

// project imports
import GuestGuard from 'utils/route-guard/GuestGuard';
import ProtectedAuthGuard from 'utils/route-guard/ProtectedAuthGuard';
import MinimalLayout from 'layout/MinimalLayout';
import NavMotion from 'layout/NavMotion';
import Loadable from 'ui-component/Loadable';

// login routing
const AuthLogin = Loadable(lazy(() => import('views/authentication/pages/Login3')));
const AuthForgotPassword = Loadable(lazy(() => import('views/authentication/pages/ForgotPassword3')));
const AuthMailCheck = Loadable(lazy(() => import('views/authentication/pages/CheckMail3')));
const AuthCodeVerification = Loadable(lazy(() => import('views/authentication/pages/CodeVerification3')));
const AuthResetPassword = Loadable(lazy(() => import('views/authentication/pages/ResetPassword3')));
const AppUserResetPassword = Loadable(lazy(() => import('views/authentication/pages/ResetPassword4')));
const AuthOtpVerification = Loadable(lazy(() => import('views/authentication/pages/AuthOtpVerification')));
const VerifyWebUser = Loadable(lazy(() => import('views/authentication/pages/VerifyWebUser')))
const AuthenticatorSetup = Loadable(lazy(() => import('views/authentication/pages/AuthenticatorSetup')));
const AuthenticatorVerification = Loadable(lazy(() => import('views/authentication/pages/AuthenticatorVerification')));
const AuthenticatorValidation = Loadable(lazy(() => import('views/authentication/pages/AuthenticatorValidation')));
const AuthenticatorRecoveryCodeValidation = Loadable(lazy(() => import('views/authentication/pages/AuthenticatorRecoveryCodeValidation')));
const AuthenticatorReset = Loadable(lazy(() => import('views/authentication/pages/AuthenticatorReset')));
const AuthenticatorRecoveryCode = Loadable(lazy(() => import('views/authentication/pages/AuthenticatorRecoveryCode')));
const ResetAuthenticatorSuccess = Loadable(lazy(() => import('views/authentication/pages/ResetAuthenticatorSuccess')));
// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
    path: '/',
    element: (
        <NavMotion>
            <GuestGuard>
                <MinimalLayout />
            </GuestGuard>
        </NavMotion>
    ),
    children: [
        {
            path: '/',
            element: <AuthLogin />
        },
        {
            path: '/login',
            element: <AuthLogin />
        },
        {
            path: '/forgot',
            element: <AuthForgotPassword />
        },
        {
            path: '/reset-password',
            element: <AuthResetPassword />
        },
        // {
        //     path: '/app-user-forgot',
        //     element: <AppUserForgotPassword />
        // },
        {
            path: '/app-user-reset-password',
            element: <AppUserResetPassword />
        },
        {
            path: '/verify-app-user-token',
            element: <VerifyWebUser />
        },
        {
            path: '/mail-check',
            element: <AuthMailCheck />
        },
        {
            path: '/code-verification',
            element: <AuthCodeVerification />
        },
        {
            path: '/auth-code-verification',
            element: <AuthOtpVerification />
        },
        {
            path: '/setup-mfa',
            element: <ProtectedAuthGuard><AuthenticatorSetup /></ProtectedAuthGuard>
        },
        {
            path: '/mfa-validation',
            element: <ProtectedAuthGuard><AuthenticatorValidation /></ProtectedAuthGuard>
        },
        {
            path: '/mfa-verification',
            element: <ProtectedAuthGuard><AuthenticatorVerification /></ProtectedAuthGuard>
        },
        {
            path: '/mfa-recovery-code-validation',
            element: <ProtectedAuthGuard><AuthenticatorRecoveryCodeValidation /></ProtectedAuthGuard>
        },
        {
            path: '/reset-authenticator',
            element: <AuthenticatorReset />
        },
         {
            path: "/mfa-recovery-code",
            element: <AuthenticatorRecoveryCode />,
        },
        {
            path: '/reset-authenticator-success',
            element: <ProtectedAuthGuard><ResetAuthenticatorSuccess /></ProtectedAuthGuard>
        }
    ]
};

export default LoginRoutes;
